<template>
  <div>
    <v-dialog
      v-model="activo"
      max-width="1000"
    >
      <v-card
        flat
      >
        <v-card-title>
          <div v-if="detalle.length > 0">Editar Detalle para Factura {{ detalle[0].compra_id }}</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="activo = false"><v-icon title="Cerrar">fas fa-times</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-row :no-gutters="$vuetify.breakpoint.xs">
            <v-col cols="12">
              <v-data-table
                class="cebra elevation-2"
                :headers="headers"
                :items="detalle"
                dense
                hide-default-footer
              >
                <!-- este template se usa para aplicar formato a las columnas que tengan la propeidad formatter -->
                <template
                  v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))"
                  v-slot:[`item.${header.value}`]="{ value }"
                >
                  {{ header.formatter(value) }}
                </template>
                <!-- Tasa -->
                <template v-slot:[`item.tasa`]="{ item }">
                  {{ roundNumber(item.tasa, 3) * 100 }}%
                </template>
                <!-- Cantidad -->
                <template v-slot:[`item.cantidad`]="{ item }">
                  <v-row class="d-flex justify-center" no-gutters>
                    <v-text-field 
                      :id="refCant"
                      :ref="refCant"
                      v-model="item.cantidad" 
                      type="number" 
                      outlined 
                      dense hide-details 
                      style="width: 50px;"
                      @blur="completarDetalle()"
                      @keypress.native.enter="$refs[refCant].blur()"
                    ></v-text-field>
                  </v-row>
                </template>
                <!-- Precio Unitario -->
                <template v-slot:[`item.precio`]="{ item }">
                  <v-row class="d-flex justify-center" no-gutters>
                    <v-text-field 
                      :id="refPrecio"
                      :ref="refPrecio"
                      v-model="item.precio" 
                      type="number" 
                      outlined 
                      dense 
                      hide-details 
                      style="width: 120px;"
                      prefix="$"
                      @blur="completarDetalle()"
                      @keypress.native.enter="$refs[refPrecio].blur()"
                    ></v-text-field>
                  </v-row>
                </template>
                <!-- Iva -->
                <template v-slot:[`item.iva`]="{ item }">
                  <v-row class="d-flex justify-center" no-gutters>
                    <v-text-field 
                      :id="refIva"
                      :ref="refIva"
                      v-model="item.iva" 
                      type="number" 
                      outlined 
                      dense 
                      hide-details 
                      style="width: 120px;"
                      prefix="$"
                      @blur="completarDetalle(1)"
                      @keypress.native.enter="$refs[refIva].blur()"
                    ></v-text-field>
                  </v-row>
                </template>
                <!-- Acciones y modal para confirmar -->
                <template v-slot:[`item.acciones`]="{ item }">
                  <v-btn icon small color="success" v-if="item" @click="emitirDetalle()"><v-icon>fas fa-check</v-icon></v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { format_money, cadenaVacia, roundNumber } from '../../util/utils'
export default {
  props: {
    datos: {
      type: Object,
      default(){
        return {}
      }
    },
  },
  computed: {
    activo: {
      get(){
        return this.datos.activo
      },
      set(value){
        this.$emit('setearModalDetalle', value)
      }
    },
    detalle: {
      get(){
        return this.datos.detalle
      }
    },
    tipo_factura: {
      get(){
        return this.datos.tipo_factura
      }
    }
  },
  data() {
    return {
      headers: [
        { text: 'Cod.', align: 'center', value: 'concepto_codigo' },
        { text: 'Nombre', align: 'center', value: 'concepto_nombre' },
        { text: 'Cantidad', align: 'center', value: 'cantidad' },
        { text: 'Precio', align: 'center', value: 'precio', formatter: format_money },
        { text: 'Tasa', align: 'center', value: 'tasa' },
        { text: 'Importe', align: 'center', value: 'importe', formatter: format_money },
        { text: 'Iva', align: 'center', value: 'iva', formatter: format_money },
        { text: '', align: 'center', value: 'acciones' }
      ],
      refCant: 'refCant',
      refPrecio: 'refPrecio',
      refIva: 'refIva',
      roundNumber: roundNumber
    }
  },
  methods: {
    completarDetalle(opcion){
      if (cadenaVacia(this.detalle[0].cantidad) || this.detalle[0].cantidad == 0) this.detalle[0].cantidad = 1
      if (cadenaVacia(this.detalle[0].precio)) this.detalle[0].precio = 0
      if (cadenaVacia(this.detalle[0].iva)) this.detalle[0].iva = 0
      this.detalle[0].cantidad = parseInt(this.detalle[0].cantidad)
      this.detalle[0].precio = roundNumber(this.detalle[0].precio, 6)
      this.detalle[0].iva = roundNumber(this.detalle[0].iva, 6)
      this.detalle[0].tasa = roundNumber(this.detalle[0].tasa, 6)
      if (opcion == 1) return
      // importe total
      this.detalle[0].importe = roundNumber(this.detalle[0].cantidad * this.detalle[0].precio, 6)
      // iva
      if (this.tipo_factura != 'C') this.detalle[0].iva = roundNumber(this.detalle[0].importe * this.detalle[0].tasa, 6)
      // neto
      this.detalle[0].neto = roundNumber(this.detalle[0].importe - this.detalle[0].iva, 6)
    },
    validarForm(){
      if (cadenaVacia(this.detalle[0].cantidad) || this.detalle[0].cantidad == 0) return {valido: false, msj: 'Ingrese una Cantidad válida.'}
      if (cadenaVacia(this.detalle[0].precio) || this.detalle[0].precio == 0) return {valido: false, msj: 'Ingrese un Precio válido.'}
      if (cadenaVacia(this.detalle[0].iva)) return {valido: false, msj: 'Ingrese un Iva válido.'}
      return {valido: true, msj: 'OK'}
    },
    emitirDetalle(){
      let valido = this.validarForm()
      if (valido.valido == false){
        this.$store.dispatch('show_snackbar', {
          text: valido.msj,
          color: 'warning',
        })
        return
      }
      let item = {}
      Object.assign(item, this.detalle[0])
      this.$emit('setDetalle', item)
      this.activo = false
    }
  },
  watch: {
    
  },
}
</script>

<style>

</style>